import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as React from "react";
import { tooltip } from "../../../utils/tooltip";
import { BinaryInteraction } from "../../../api/openapi-generator";

interface Props {
  interactions: BinaryInteraction[],
}

function BinaryInteractionTable({interactions}: Props) {

  const isItself = (data: BinaryInteraction) => {
    return data.firstInteractant.intActAccession === data.secondInteractant.intActAccession;
  }

  const withBody = (data: BinaryInteraction) => {
    const interactant = data.secondInteractant;
    return <span>
    {isItself(data) ? "itself" : (
      <a href={`https://www.uniprot.org/uniprot/${interactant.uniprotAccession}`} target="_blank">
      {interactant.geneName !== null ? `${interactant.geneName} [${interactant.uniprotAccession}]` : `[${interactant.uniprotAccession}]`}
      </a>
    )}
    </span>
  }

  const intActBody = (data: BinaryInteraction) => {
    let query: string;
    const interactant = data.secondInteractant;
    if (isItself(data)) {
    const acc = interactant.uniprotAccession;
    query = `(idA:${acc} AND idB:${acc}) OR (idA:${acc} AND idB:-) OR (idA:- AND idB:${acc})`;
    } else {
    query = `id:${interactant.uniprotAccession} AND id:${interactant.uniprotAccession}`;
    }
    return <a href={`https://www.ebi.ac.uk/intact/query/${query}`} target="_blank">{interactant.uniprotAccession},{interactant.uniprotAccession}</a>
  }

  return <>
    <div className="ll-screen">
    <DataTable value={interactions}
      className="p-datatable-sm ll-binary-interaction-table"
      scrollable scrollHeight="400px"
      loading={false}
      removableSort
    >
      <Column body={withBody} header="With" style={{ flex: '0 0 25%' }} sortable />
      <Column field="numExperiments" sortable header={<>
      #Exp.{tooltip('interactions_experiments')}
      </>} bodyStyle={
      { textAlign: 'right', display: 'inline-block', flex: '0 0 15%', paddingRight: '2rem' }
      } headerStyle={
      { textAlign: 'center', display: 'inline-block', flex: '0 0 15%', paddingRight: '2rem' }
      } />
      <Column body={intActBody} sortable field="intActAccession" header="IntAct" />
    </DataTable>
    </div>
    <div className="ll-print">
      <table className="ll-binary-interaction-table">
      <thead>
        <tr>
        <th>With</th>
        <th>Supporting Experiments</th>
        <th>IntAct</th>
        </tr>
      </thead>
      <tbody>
        {interactions.map((interaction, idx) => <tr key={idx}>
        <td>{withBody(interaction)}</td>
        <td>{interaction.numExperiments}</td>
        <td>{intActBody(interaction)}</td>
        </tr>)}
      </tbody>
      </table>
    </div>
  </>

}

export default BinaryInteractionTable;
